/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_StatusInputs */

const en_task_settings_status = /** @type {(inputs: Task_Settings_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity status`)
};

const pt_br2_task_settings_status = /** @type {(inputs: Task_Settings_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status da atividade`)
};

/**
* | output |
* | --- |
* | "Activity status" |
*
* @param {Task_Settings_StatusInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_status = /** @type {((inputs?: Task_Settings_StatusInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_StatusInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_status(inputs)
	return pt_br2_task_settings_status(inputs)
});